module.exports = __webpack_public_path__ + "static/media/more_ways_to_earn_teal.36549714.svg";